import clientQrCode from "../assets/img/client_qr_code.png";
import proQrCode from "../assets/img/pro_qr_code.png";

export const CLIENT_APP_STORE_URL =
  "https://apps.apple.com/us/app/simplerenovate-get-quotes/id6739887309";

export const PRO_APP_STORE_URL =
  "https://apps.apple.com/us/app/simplerenovate-for-pros/id6754059537";

export const APP_DOWNLOAD_OPTIONS = [
  {
    id: "client",
    title: "SimpleRenovate",
    badge: "For Homeowners",
    description:
      "Post renovation projects, compare bids from trusted professionals, and manage your project from start to finish.",
    appStoreUrl: CLIENT_APP_STORE_URL,
    qrImage: clientQrCode,
    features: [
      "Post projects with photos and details",
      "Receive and compare multiple bids",
      "Chat with professionals",
      "Track project progress",
    ],
  },
  {
    id: "pro",
    title: "SimpleRenovate for Pros",
    badge: "For Professionals",
    description:
      "Browse renovation projects, submit competitive bids, connect with homeowners, and manage jobs on the go.",
    appStoreUrl: PRO_APP_STORE_URL,
    qrImage: proQrCode,
    features: [
      "Browse projects with photos and measurements",
      "Submit bids and win new work",
      "Chat with homeowners",
      "Manage jobs and payments",
    ],
  },
];

export const isMobileDownloadContext = () =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );

export const OPEN_APP_DOWNLOAD_MODAL_EVENT = "sr:open-app-download-modal";

export const openAppDownloadModal = () => {
  window.dispatchEvent(new CustomEvent(OPEN_APP_DOWNLOAD_MODAL_EVENT));
};
